<div
    class="section-content px-4 md:px-4 lg:p-0 relative z-10 mt-8 mb-8 w-full mx-auto max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%] animate">
    <div class="welcome-banner px-4 md:px-4 lg:p-0 relative z-10 mt-8 mb-8 w-full">
        <div
            class="flex justify-between items-center gap-6 p-8 bg-[var(--v2-color-secondary-500)] rounded-xl shadow-lg">
            <div>
                <h1 class="text-xl text-white font-bold mb-2">
                    <span>{{ 'words.hello' | translate }} {{ me.firstname }}!</span>
                </h1>
                <p class="text-blue-100 text-base">
                    {{ 'onboarding.welcome' | translate:{companyName: company.name} }}
                </p>
            </div>
            <div class="hidden md:block">
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-white text-opacity-70">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
            </div>
        </div>
    </div>
</div>
<div class="bg-gray-50 py-8">
    <!--plantilla skeleton -->
    <div *ngIf="isSkeletonLeaders; else tableMd">
        <div
            class=" px-4 md:px-4 lg:p-0 relative z-10 mb-8 w-full mx-auto max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%] ">
            <div
                class="container-onboarding__content__left bg-white rounded-2xl p-8 w-full lg:w-3/5 border border-gray-100 shadow-sm">
                <!-- Encabezado -->
                <div class="flex justify-between items-center mb-6">
                    <div class="h-6 w-1/4 bg-gray-200 rounded"></div>
                    <div class="h-6 w-20 bg-gray-200 rounded"></div>
                </div>

                <!-- Lista de items -->
                <div class="space-y-4 mt-8">
                    <!-- Item 1 - Perfil -->
                    <div class=" rounded-lg overflow-hidden">
                        <div class="bg-gray-100 rounded-lg p-4 flex justify-between items-center">
                            <div class="h-5 w-1/3 bg-gray-300 rounded"></div>
                            <div class="h-4 w-4 bg-gray-300 rounded"></div>
                        </div>
                        <div class="p-4 space-y-3">
                            <div class="flex items-center gap-3">
                                <div class="h-4 w-4 bg-gray-200 rounded-full"></div>
                                <div class="h-4 w-1/2 bg-gray-200 rounded"></div>
                            </div>
                            <div class="flex items-center gap-3">
                                <div class="h-4 w-4 bg-gray-200 rounded-full"></div>
                                <div class="h-4 w-1/3 bg-gray-200 rounded"></div>
                            </div>
                            <div class="flex items-center gap-3">
                                <div class="h-4 w-4 bg-gray-200 rounded-full"></div>
                                <div class="h-4 w-2/3 bg-gray-200 rounded"></div>
                            </div>
                        </div>
                    </div>

                    <!-- Item 2 - Contenido principal -->
                    <div class=" rounded-lg overflow-hidden">
                        <div class="p-4 flex justify-between items-center">
                            <div class="h-5 w-1/2 bg-gray-200 rounded"></div>
                            <div class="flex items-center gap-2">
                                <div class="h-4 w-16 bg-gray-200 rounded"></div>
                                <div class="h-4 w-4 bg-gray-200 rounded"></div>
                            </div>
                        </div>

                    </div>

                    <!-- Item 3 - Características -->
                    <div class="mt-0 rounded-lg overflow-hidden">

                        <div class="px-4 space-y-3">
                            <div class="flex items-center gap-3">
                                <div class="h-4 w-4 bg-gray-200 rounded-full"></div>
                                <div class="h-4 w-1/3 bg-gray-200 rounded"></div>
                            </div>
                            <div class="flex items-center gap-3">
                                <div class="h-4 w-4 bg-gray-200 rounded-full"></div>
                                <div class="h-4 w-1/4 bg-gray-200 rounded"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>


    <ng-template #tableMd>
        <div class=" px-4 md:px-4 lg:p-0 relative z-10 mb-8 w-full mx-auto max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%] "
            *ngIf="content">
            <div
                class="container-onboarding__content__left bg-white rounded-2xl p-6 w-full lg:w-3/5 border border-gray-100 shadow-sm">
                <div class="box">
                    <div class="font-semibold flex flex-row text-gray-500 justify-between">
                        <h2 class="text-lg font-semibold text-gray-700">{{ 'onboarding.start' | translate }}</h2>

                        <msc-button class="msc-button--primary" icon="icon-play-circle" palette="secondary"
                            (click)="start()">
                            {{ getTranslate() | translate }}
                        </msc-button>
                    </div>

                    <div class="content__list">
                        <div class="content__list__item" [ngClass]="{'active': displays.profile}">
                            <div class="item-title bg-gray-100" (click)="displayed('profile')">
                                <span class="item-title__title text-gray-700">
                                    {{ 'onboarding.profile' | translate }}
                                </span>

                                <div class="item-action">
                                    <i class="icon icon-arrow-ios-down"></i>
                                </div>
                            </div>

                            <div class="item-content item-content--shadow border">
                                <div class="item-content__title">
                                    <div class="flex">
                                        <i class="icon icon-checkmark color--green"></i>

                                        <span class="normal text-gray-500">{{ 'words.interface-language' | translate
                                            }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="item-content item-content--shadow border ">
                                <div class="item-content__title">
                                    <div class="flex">
                                        <i class="icon"
                                            [ngClass]="{'icon-close color--red': me.learningLanguages.length === 0, 'icon-checkmark color--green': me.learningLanguages.length > 0}"></i>

                                        <span class="normal  text-gray-500">{{ 'words.learning-languages' | translate
                                            }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="item-content item-content--shadow border">
                                <div class="item-content__title">
                                    <div class="flex">
                                        <i class="icon"
                                            [ngClass]="{'icon-close color--red': !me.headline || !me.companyName, 'icon-checkmark color--green': me.headline && me.companyName}"></i>

                                        <span class="normal  text-gray-500">{{ 'words.personal.information' | translate
                                            }} ({{ 'words.job'
                                            | translate }} & {{ 'words.company-name' | translate }})</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="content__list__item" [ngClass]="{'active': displays.content}">
                            <div class="item-title flex justify-between items-center w-full"
                                (click)="displayed('content')">
                                <span class="item-title__title item-title__title--limit text-gray-700">
                                    {{ content.title }}
                                </span>
                                <div class="flex items-center gap-2">
                                    <div class="item-data flex items-center gap-1">
                                        <i class="icon icon-timer"></i>

                                        <span>{{ content.duration || 0 | duration }}</span>

                                        <msc-tag [text]="getType() | translate" [color]="getColor()"></msc-tag>
                                    </div>

                                    <div class="item-action">
                                        <i class="icon icon-arrow-ios-down"
                                            *ngIf="onboarding.context === 'traject' || onboarding.context === 'course_instance'"></i>
                                    </div>
                                </div>
                            </div>

                            <div *ngFor="let section of content.sections; let index=index">
                                <div class="item-content item-content--shadow border"
                                    [ngClass]="{'active': displays.sections[index]}">
                                    <div class="item-content__title item-content__title--selectable"
                                        (click)="displayed('sections', index)">
                                        <span class="text-gray-500 text-sm">{{ section.title }}</span>

                                        <div class="item-content__data">
                                            <i class="icon icon-trending-up"></i>

                                            <div class="data-progress">
                                                <msc-progress-bar [progress]="section.progress?.finishedPercent"
                                                    [label]="true" [icon]="false" [force]="true"></msc-progress-bar>
                                            </div>
                                        </div>

                                        <div class="item-content__action">
                                            <i class="icon icon-arrow-ios-down"></i>
                                        </div>
                                    </div>

                                    <div class="item-content__item"
                                        *ngFor="let sectionContent of section.sectionContents">
                                        <span>
                                            <i class="icon" [attr.class]="getContentIcon(sectionContent.context)"></i>

                                            {{ sectionContent.title }}
                                        </span>

                                        <div class="item-content__item__data">
                                            <i class="icon icon-trending-up"></i>

                                            <div class="data-progress">
                                                <msc-progress-bar [progress]="sectionContent.session?.progress"
                                                    [label]="true" [icon]="false" [force]="true"></msc-progress-bar>
                                            </div>
                                        </div>

                                        <div class="item-content__empty"></div>
                                    </div>
                                </div>
                            </div>

                            <div *ngFor="let item of content.contents; let index=index">
                                <div class="item-content item-content--shadow border"
                                    *ngIf="item.context === 'content'">
                                    <div class="item-content__title">
                                        <span>
                                            <i class="icon text-secondary-500"
                                                [attr.class]="getContentIcon(item.playerContext)"></i>

                                            {{ item.data.title || ('words.untitled' | translate) }}
                                        </span>

                                        <div class="item-content__data">
                                            <i class="icon icon-trending-up"></i>

                                            <div class="data-progress">
                                                <msc-progress-bar [progress]="item.session?.progress" [label]="true"
                                                    [icon]="false" [force]="true"></msc-progress-bar>
                                            </div>
                                        </div>

                                        <div class="item-content__empty"></div>
                                    </div>
                                </div>

                                <div class="item-content-path item-content-path--shadow"
                                    *ngIf="item.context === 'course'" [ngClass]="{'active': displays.courses[index]}">
                                    <div class="item-content-path__title item-content-path__title--selectable"
                                        (click)="displayed('courses', index)">
                                        <div class="item-path-title">
                                            <div class="item-path-cover"
                                                [ngStyle]="{'background-image': 'url(' + (item.data.picture ? item.data.picture + '?size=512' : 'https://static.myskillcamp.com/lxp/images/logo-empty-state-' + item.data.id % 7 + '.jpg') + ')'}">
                                            </div>

                                            <span>{{ item.data.title || ('words.untitled' | translate) }}</span>
                                        </div>

                                        <div class="item-content-path__data">
                                            <i class="icon icon-trending-up"></i>

                                            <div class="data-progress">
                                                <msc-progress-bar [progress]="item.session?.progress" [label]="true"
                                                    [icon]="false" [force]="true"></msc-progress-bar>
                                            </div>
                                        </div>

                                        <div class="item-content-path__action">
                                            <i class="icon icon-arrow-ios-down"></i>
                                        </div>
                                    </div>

                                    <div *ngIf="courses[item.id]">
                                        <div class="item-content"
                                            *ngFor="let section of courses[item.id].sections; let index=index"
                                            [ngClass]="{'active': displays.sectionContents[item.id + index]}">
                                            <div class="item-content__title item-content__title--selectable"
                                                (click)="displayed('sectionContents', item.id + index)">
                                                <span>{{ section.title || ('words.untitled' | translate) }}</span>

                                                <div class="item-content__data">
                                                    <i class="icon icon-trending-up"></i>

                                                    <div class="data-progress">
                                                        <msc-progress-bar [progress]="section.progress?.finishedPercent"
                                                            [label]="true" [icon]="false"
                                                            [force]="true"></msc-progress-bar>
                                                    </div>
                                                </div>

                                                <div class="item-content__action">
                                                    <i class="icon icon-arrow-ios-down"></i>
                                                </div>
                                            </div>

                                            <div class="item-content__item"
                                                *ngFor="let sectionContent of section.sectionContents">
                                                <span>
                                                    <i class="icon text-secondary-500"
                                                        [attr.class]="getContentIcon(sectionContent.context)"></i>

                                                    {{ sectionContent.title || ('words.untitled' | translate)}}
                                                </span>

                                                <div class="item-content__item__data">
                                                    <i class="icon icon-trending-up"></i>

                                                    <div class="data-progress">
                                                        <msc-progress-bar [progress]="sectionContent.session?.progress"
                                                            [label]="true" [icon]="false"
                                                            [force]="true"></msc-progress-bar>
                                                    </div>
                                                </div>

                                                <div class="item-content__item__empty"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="load-more justify-center" *ngIf="content.pagination">
                                <msc-button class="msc-button--secondary" (click)="loadMoreContent()"
                                    *ngIf="content.pagination.currentPage < content.pagination.lastPage && !journeyContentLoading">
                                    {{ 'words.load-more' | translate }}</msc-button>
                                <msc-common-spinner *ngIf="journeyContentLoading"></msc-common-spinner>
                            </div>
                        </div>

                        <div class="content__list__item" [ngClass]="{'active': displays.features}">
                            <div class="item-title" (click)="displayed('features')">
                                <span class="item-title__title text-gray-700">
                                    <i class="icon icon-gift text-secondary-500"></i>

                                    {{ 'onboarding.unlock' | translate }}
                                </span>

                                <div class="item-action">
                                    <i class="icon icon-arrow-ios-down"></i>
                                </div>
                            </div>

                            <div class="item-content item-content--shadow border">
                                <div class="item-content__title">
                                    <div class="flex">
                                        <i class="icon"
                                            [ngClass]="{'icon-close color--red': !access.permissions.companyAccessPlatform, 'icon-checkmark color--green': access.permissions.companyAccessPlatform}"></i>

                                        <span class="text-gray-500">{{ 'words.dashboard' | translate }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="item-content item-content--shadow border">
                                <div class="item-content__title">
                                    <div class="flex">
                                        <i class="icon"
                                            [ngClass]="{'icon-close color--red': !access.permissions.companyAccessPlatform, 'icon-checkmark color--green': access.permissions.companyAccessPlatform}"></i>

                                        <span>{{ 'words.my-training-courses' | translate }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="item-content item-content--shadow border" *ngIf="sidebar.settings.catalogue">
                                <div class="item-content__title">
                                    <div class="flex">
                                        <i class="icon"
                                            [ngClass]="{'icon-close color--red': !access.permissions.companyAccessPlatform, 'icon-checkmark color--green': access.permissions.companyAccessPlatform}"></i>

                                        <span>{{ 'words.catalogue' | translate }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="item-content item-content--shadow border" *ngIf="sidebar.settings.group">
                                <div class="item-content__title">
                                    <div class="flex">
                                        <i class="icon"
                                            [ngClass]="{'icon-close color--red': !access.permissions.companyAccessPlatform, 'icon-checkmark color--green': access.permissions.companyAccessPlatform}"></i>

                                        <span>{{ 'words.communities' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--
    <div class="container-onboarding__content__right col-4 col-sm-4 col-xxs-12">
        <div class="box box-contact" *ngIf="experience && experience.contact">
            <div class="box-contact__question">
                <div>{{ 'words.a-question' | translate }}</div>

                <msc-button class="msc-button--primary" palette="secondary"
                    (click)="conversationWith(experience.contact)">
                    {{ 'words.contact-us' | translate }}
                </msc-button>
            </div>

            <div class="box-contact__avatar">
                <div class="avatar-contact">
                    <msc-common-avatar [label]="experience.contact?.name"
                        [pictureURL]="experience.contact?.picture ? (experience.contact?.picture + '?size=128') : null">
                    </msc-common-avatar>

                    <div class="avatar__content">
                        <p class="profile__name text-secondary-800">{{ experience.contact.name }}</p>
                        <div class="profile__job" *ngIf="experience.contact.headline">
                            {{ experience.contact.headline }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <msc-timeline [context]="'company'" [contextId]="company.id" [isDashboard]="true" [displayCamp]="true"
            [small]="true" [newPost]="true"></msc-timeline>
    </div>-->
        </div>
    </ng-template>
</div>